import { AlignType, MarginType } from 'common/types/styleTypes'
import {
  marginCss,
  mobileMarginCss,
  mobileTextCss,
  textCss,
} from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

type BlogPostAnnounceHeaderUiProps = {
  fontSize: number
  color: string
  fontFamily?: string
  fontWeight?: string
  fontStyle?: string
  letterSpacing?: number
  textAlign: AlignType
  lineHeight?: number
  mobileFontSize?: number
  mobileColor?: string
  mobileFontFamily?: string
  mobileFontWeight?: string
  mobileFontStyle?: string
  mobileLineHeight?: number
  mobileLetterSpacing?: number
  mobileTextAlign?: AlignType
  margin?: Partial<MarginType>
  mobileMargin?: Partial<MarginType>
}

const BlogPostAnnounceHeaderUi = styled.div<BlogPostAnnounceHeaderUiProps>`
  font-size: 27px;
  ${textCss};
  ${marginCss}
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`

export default BlogPostAnnounceHeaderUi
